import Container from '@mui/material/Container';
import Fade from '@mui/material/Fade';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { signOut } from 'firebase/auth';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../core/firebase';
import { useQuery } from '../core/hooks';
import { Logo, LogoType } from '../widgets/logo';
import PhoneSignUp from './phone-signup/PhoneSignUp';
import ThirdPartySignin from './ThirdPartySignin';
import './SignInScreen.css';


export interface ISignInPage {
  defaultRedirect: string;
}

export default function SignInScreen(props: ISignInPage) {
  const query = useQuery();
  const [active, setActive] = useState(false);
  const [redirect, setRedirect] = useState(props.defaultRedirect);
  const navigate = useNavigate();

  const handleSuccess = () => {
    navigate(redirect);
  };

  useEffect(() => {
    console.log('Query');
    const _redirect: string = query.has('redirect') ? query.get('redirect') as string : props.defaultRedirect;
    if (_redirect.indexOf('/signin') === -1) {
      setRedirect(_redirect);
    }
    if (_redirect === '/') {
      setRedirect(props.defaultRedirect);
    }
    console.log('REDIRECT', _redirect);
    setTimeout(() => {
      setActive(true);
    }, 200);
  }, []);

  return (
    <Fade
      in={active}
      timeout={1200}
    >
      <Grid
        container
        direction="column"
        sx={{
          position: 'relative',
          textAlign: 'center',
          background: (theme) => `linear-gradient(60deg, ${theme.palette.primary.main} 0%,${theme.palette.primary.dark} 100%)`,
          color: '#fff'
        }}
      >

        <Grid container>
          <Container maxWidth="xs" disableGutters>
            <Grid
              container
              direction="column"
              justifyContent="space-between"
              alignItems="center"
              sx={{
                padding: 8,
                '& > :not(:last-child)': {
                  marginBottom: 12
                }
              }}
            >
              <Grid item container style={{ flexGrow: 1 }} direction="column" justifyContent="center"
                    alignItems="center">
                <Logo width={300} logo={LogoType.BLUE_INVERT_FULL_BONE}/>
                <Typography variant="body1" style={{ color: '#fff', textAlign: 'center' }}>
                  A Smarter Way To Pet Parenting
                </Typography>
              </Grid>
              <Grid item>
                <PhoneSignUp label="Admin Signin" onSuccess={handleSuccess} phone={''}/>
              </Grid>
              <Grid item container alignItems="center">
                <ThirdPartySignin onSuccess={handleSuccess} onError={(error) => {
                  console.error(error);
                }}/>
              </Grid>
            </Grid>
          </Container>
        </Grid>

        <div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 24 150 28"
            preserveAspectRatio="none"
            shapeRendering="auto"
            style={{
              position: 'relative',
              width: '100%',
              height: '15vh',
              /*Fix for safari gap*/
              marginBottom: -7,

              minHeight: 100,
              maxHeight: 150
            }}
          >
            <defs>
              <path id="gentle-wave" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"/>
            </defs>
            <g className="parallax">
              <use xlinkHref="#gentle-wave" x="48" y="0" fill="rgba(255,255,255,0.7"/>
              <use xlinkHref="#gentle-wave" x="48" y="3" fill="rgba(255,255,255,0.5)"/>
              <use xlinkHref="#gentle-wave" x="48" y="5" fill="rgba(255,255,255,0.3)"/>
              <use xlinkHref="#gentle-wave" x="48" y="7" fill="#fff"/>
            </g>
          </svg>
        </div>

        <div style={{ flexGrow: 1, backgroundColor: '#fff' }}/>

      </Grid>
    </Fade>
  );

}
